import React, { createContext, useContext, useState, useEffect } from 'react';

// Initialize counts from localStorage or default to 0
const getInitialCount = (key) => {
  const savedCount = localStorage.getItem(key);
  return savedCount !== null ? Number(savedCount) : 0;
};

const CarContext = createContext();

export const CarContextProvider = ({ children }) => {
  const [carCount, setCarCount] = useState(getInitialCount('carCount'));
  const [filteredCarCount, setFilteredCarCount] = useState(getInitialCount('filteredCarCount'));
  const [uploadPicturesCount, setUploadPicturesCount] = useState(getInitialCount('uploadPicturesCount'));
  const [placeBidsCount, setPlaceBidsCount] = useState(getInitialCount('placeBidsCount'));
  const [paymentsCount, setPaymentsCount] = useState(getInitialCount('paymentsCount'));
  const [takeDeliveryCount, setTakeDeliveryCount] = useState(getInitialCount('takeDeliveryCount'));
  const [nocCount, setNocCount] = useState(getInitialCount('nocCount'));

  // Save counts to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('carCount', carCount);
    localStorage.setItem('filteredCarCount', filteredCarCount);
    localStorage.setItem('uploadPicturesCount', uploadPicturesCount);
    localStorage.setItem('placeBidsCount', placeBidsCount);
    localStorage.setItem('paymentsCount', paymentsCount);
    localStorage.setItem('takeDeliveryCount', takeDeliveryCount);
    localStorage.setItem('nocCount', nocCount);
  }, [carCount, filteredCarCount, uploadPicturesCount, placeBidsCount, paymentsCount, takeDeliveryCount, nocCount]);

  return (
    <CarContext.Provider value={{ 
      carCount, 
      setCarCount, 
      filteredCarCount, 
      setFilteredCarCount,
      uploadPicturesCount,
      setUploadPicturesCount,
      placeBidsCount,
      setPlaceBidsCount,
      paymentsCount,
      setPaymentsCount,
      takeDeliveryCount,
      setTakeDeliveryCount,
      nocCount,
      setNocCount
    }}>
      {children}
    </CarContext.Provider>
  );
};

export const useCarContext = () => useContext(CarContext);